import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* publisherSagas() {
  yield mapSagasFromConfigurations('publishers')(configurations)
}

export default publisherSagas;



// WEBPACK FOOTER //
// ./src/state/modules/publisher/sagas.js